import { common } from './common';
import { nav } from './nav';
import { auth } from './auth';
import { qagentHome } from './qagentHome';
import { qagentChat } from './qagentChat';
import { qagentDocument } from './qagentDocument';
import { playbooks } from './playbooks';
import { onboarding } from './onboarding';
import { access } from './access';
import { members } from './members';
import { comparisons } from './comparisons';
import { cost } from './cost';
import { account } from './account';
import { meetings } from './meetings';
import { feedback } from './feedback';
import { projectUploads } from './projectUploads';

export const en = {
  common,
  nav,
  auth,
  qagentHome,
  qagentChat,
  qagentDocument,
  playbooks,
  onboarding,
  access,
  members,
  comparisons,
  cost,
  account,
  meetings,
  feedback,
  projectUploads,
};

export type Dictionary = typeof en;
